import { ChevronLeftIcon as LibChevronLeftIcon } from '@heroicons/react/outline';
import * as React from 'react';

import BaseIcon, { IconProps } from '@/components/icons/base-icon';

const ChevronLeftIcon = (props: IconProps) => {
  return <BaseIcon Icon={LibChevronLeftIcon} {...props} />;
};

export default ChevronLeftIcon;
